import { BrowserRouter, Routes, Route }
  from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import GeneratorPage from './pages/GeneratorPage';
import BuilderPage from './pages/BuilderPage';
import NotFoundPage from './pages/NotFoundPage';
import { useUser } from './hooks/useUser'; 
import ContactPage from './pages/ContactPage';
import SuccessPage from './pages/SuccessPage';
import BillingPage from './pages/BillingPage';
import TermsPage from './pages/Termspage';
import PrivacyPage from './pages/Privacypage';
import CookieBanner from './pages/Cookiebanner';
import { Analytics } from "@vercel/analytics/react"


// ← ADD this inner component!
const AppContent = () => {
  useUser(); // ← Syncs user on login!
  
  return (
    <div className="min-h-screen bg-gray-950
                    flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/"
                 element={<HomePage />} />
          <Route path="/generator"
                 element={<GeneratorPage />} />
          <Route path="/builder"
                 element={<BuilderPage />} />
          <Route path="*"
                 element={<NotFoundPage />} />
          <Route path="/contact"
                 element={<ContactPage />} />
          <Route path="/success"
                 element={<SuccessPage />} />
         <Route path="/billing"
                 element={<BillingPage />} />
        <Route path="/privacy" 
                 element={<PrivacyPage />} />
        <Route path="/terms"  
                 element={<TermsPage />} />
        </Routes>
      </main>
      <Footer />
       <CookieBanner /> 
        <Analytics />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent /> {/* ← uses useUser inside */}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1f2937',
            color: '#e5e7eb',
            border: '1px solid #374151',
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;